export default {
    radio: {
        radio: "Radio",
        day: "Día",
        unknown: "No Establecido",
        current: "Actual",
        target: "Objetivo",
        bulkTuningCounts: "Tuning Radio Distribución",
        bulkTuningCountsGraphLabel: "Cuentas de Radio",
        trafficType: "Tipo de Tráfico",
        trafficTypes: {
            BOOST: "Aumentar",
            BULK: "A granel",
            BUDDY: "Amigo",
            DOWNLINK: "Enlace descendente",
            L2ACK_1: "L2ACK 1",
            L2ACK_2: "L2ACK 2",
            L2ACK_3: "L2ACK 3",
            POLL_RESPONSE: "Encuesta/Respuesta",
            PRIORITY: "Prioridad",
            RTS: "RTS",
            UPLINK: "Enlace ascendente",
        },
        metricsNav: "Métrica",
        metricsList: "Lista de radios",
        metricsDashboard: "Panel de radio",
        tuningNav: "Afinación",
        tuningConfig: "Configuración de sintonización",
        tuningResults: "Resultados de ajuste",
        tuningJson: "Ajuste de JSON",
        rapidTuning: "Sintonización rápida",
        pendingTuningChanges: "Cambios de configuración pendientes",
        channelNav: "Canales",
        buddyNav: "Amigas",
        activeCommands: "Comandos activos",
        channelConfig: "Configuración del canal",
        channelResults: "Resultados del canal",
        buddyConfig: "Configuración de amigos",
        buddyResults: "Resultados de amigos",
        ipEnabled: "IP habilitada",
        tuningOption: "Acciones de ajuste posteriores",
        encrypted:"Cifrado",
        builtInDashboards: {
            baseEndpointConfiguration: "NCS: Configuración de punto de acceso base",
            transmitReceiveConfiguration: "NCS: Configuración de Transmitir/Recibir",
            frequencyConfiguration: "NCS: Configuración de Frecuencia",
            tuningGroupCounts: "NCS: Recuento de Grupos de Afinación"
        },
        buddy: {
            isSOSBuddy: "Compañero de rescate",
            isVitalBuddy: "Compañero vital",
            inBuddySupportDownlinkChannel: "Enlace descendente de soporte de Canal de amigos",
            mPassBuddyRepeatEnabled: 'mPass Buddy Repeat',
            buddyConfigChangeStartTime: 'Hora de inicio del cambio de configuración de amigo',
            staticRebroadcasterTargetState: "Estado de destino del retransmisor estático",
            staticRebroadcasterTargetStateNames: {
                PROMOTE_TO: "Promover",
                DEMOTE_FROM: "Degradar"
            },
            forwardMode: "Modo de reenvío de amigos",
            forwardModes: {
                C_AND_I: "C & I",
                DEFAULT: "Defecto",
                null: "No establecido",
            },
            messageMode: "Modo de mensaje de amigo",
            messageModes: {
                SEND_1_OF_8: "Enviar 1 de 8",
                SEND_1_OF_16: "Enviar 1 de 16",
                SEND_ALL: "Envia todo",
                SEND_NONE: "Enviar ninguno",
                null: "No establecido"
            },
            randomQueueTime: "Randomly Assign Buddy Queue Time"
        },
        rssiDistributeThreshold: "Umbral de distribución RSSI (dB)",
        cmdDisabled: "El procesamiento de comandos para radios está deshabilitado",
        cmdEnabled: "El procesamiento de comandos para Radios está habilitado",
        config: {
            caTab: "Asignación de canales",
            carTab: "Resultados de asignación de canales",
            ragTab: "Configuración de condición especial",
            ragrTab: "Resultados de condiciones especiales",
            tcTab: "Configuración de ajuste",
            thTab: "Resultados del grupo de ajuste",
            bcTab: "Configuración de Compañero",
            bchTab: "Resultados de Compañero",
            acTab:"Comandos Activos"
        },
        sosBuddyRepId: 'ID de representante de amigo de SOS',
        sosOrdRepId: 'ID de representante de SOS ORD',
        mPassBuddyRepeatEnabled: 'mPass Buddy Repeat',
        buddySupportState: "Estado de soporte de amigos",
        buddySupportStateTitle: 'Estado de soporte de amigos',
        buddySupportStateNames: {
            NORMAL: "Discapacitado",
            BUDDY: "Amigo",
            STATIC_REBROADCASTER: "Transmisor Estático",
            ORD: "Dispositivo Fuera del Alcance",
            null: "No Establecido"
        },
        sourceId: 'ID de fuente',
        currentChannelPair: "Par de canales actual",
        channelPairIndex: "Índice de pares de canales",
        targetBulkChannelPair: "Par de canales objetivo a granel",
        networkPlanNotSet: "No establecido en el plan de red",
        targetUplinkFreq: "Frecuencia de enlace ascendente objetivo",
        targetDownlinkFreq: "Frecuencia de enlace descendente objetivo",
        previousChannelPair: "Par de canales anterior",
        configCommsHub: "Configurar Comms Hub",
        configNA: "Configurar NA Radio",
        configFNv1: "Configurar radio FNv1",
        configFNv2: "Configurar radio FNv2",
        activeAlarmCount: 'Alarma activa',
        threshold: "Limite",
        noDevices: "No hay dispositivos para esta radio",
        radioEndpoints: "Puntos finales de radio",
        deleteRadios: "Eliminar radios",
        deleteRadiosPrompt: '¿Estás seguro de que deseas eliminar las radios del archivo? {fileName}?',
        deleteRadiosWithInvalidIds: 'Los siguientes identificadores en el archivo no eran válidos y fueron ignorados: {ids}',
        deleteRadiosAsync: 'Eliminar solicitud de radios enviada. Vaya a Historial para ver el estado del comando.',
        deleteRadiosInvalidFile: 'Archivo no válido subido',
        deleteRadiosInvalidFileSize: 'Archivo no válido cargado, se pueden eliminar un máximo de 5000 radios a la vez',
        deleteRadiosError: 'Error al eliminar radios',
        id: "ID de radio",
        repId: "ID de radio",
        radioId: "ID de radio",
        fqdn: "FQDN",
        deviceType: "Tipo de dispositivo",
        deviceTypeFirmware: "Firmware por tipo de dispositivo",
        deviceTypeFirmwareTitle: 'Firmware por tipo de dispositivo',
        deviceTypeFirmwareGraphLabel: "Puntos finales",
        radioType: "Tipo de radio",
        deviceTypeCategories: "Categorías de tipo de dispositivo",
        encryption: "Cifrado",
        utilityType: "Tipo de utilidad",
        lifecycleStateTimeline: 'Estado del ciclo de vida a lo largo del tiempo',
        name: "Nombre",
        zipCode: "Código Postal",
        postalCode: "Código postal",
        selectSync: "Sincronizar radios",
        syncAll:"Sincronizar todas las radios",
        syncUpdated:"Sincronizar radios actualizadas",
        syncRadio: "Sincronizar",
        cancel: "Cancelar",
        city: "Ciudad",
        sets: "Conjuntos",
        latlong: "Lat/Long",
        latlongCalc: "Lat/Long (Estimado)",
        activeAlarms: "Alarmas activas",
        mptLastHeard: "MPT Último Escuchado",
        lastImportDate:"Último cambio de importación de RNI",
        mptPercentYesterday: "MPT Por Ciento Ayer",
        esmReadsYesterday: "ESM Lee Ayer",
        esmSnapshotCountYesterday: "Instantáneas pof Lectura",
        lastHeard: "Último Oído",
        lastHeardDuration: "Último Oído",
        lastHeardDurationFilterName: "Duración de la última escucha",
        lastHeard30DaysStale: "Escuchado por última vez hace más de 30 días",
        lastHeardNotSet: "Ha sido escuchado",
        newlyHeardDuration: "Recién escuchada",
        lastSetupMsg: "Último mensaje de configuración escuchado",
        installDate: "Fecha de Instalación",
        fwdlEndDate: {
            displayString: "Fecha de descarga del firmware",
            duration: "Estado de descarga de firmware",
            isInProgress: "En curso",
            notInProgress: "No en progreso",
        },
        fwdlInProgress: "Estado de descarga de firmware",
        discovered: "Sistema Descubierta",
        firstHeard: 'Escuchado por Primera Vez',
        firstHeardRni: 'Escuchado por Primera Vez por RNI',
        firstHeardNcs: 'Escuchado por Primera Vez por NCS',
        rxOpMode: "Modo de Funcionamiento del Receptor",
        rxOpModeTarget: "Afinación Modo de Funcionamiento del Receptor objetivos",
        transmitOperationalMode: "Modo Operativo del Transmisor",
        transmitOperationalModeTarget: "Afinación Modo Operativo del Transmisor objetivos",
        pingMenu: 'Ping',
        sendPingForSetup: "Hacer ping para configuración estática",
        sendPingForAdvancedSetup: "Ping para configuración avanzada",
        sendPingIP6: {
            action: "Hacer ping IP",
            queued: "Ping IP iniciado. Por favor, espere...",
            error: "El ping IP falló"
        },
        pingBaseMsg: "{pingType} enviar para radios seleccionadas.",
        pingBaseMsg2: "Para obtener más información y seguir el progreso, consulte",
        sendPingForESMMetadataSetup: "Ping para metadatos de ESM",
        sendPingForESMConfigSetup: "Hacer ping para la configuración de ESM",
        sendPingForOrdReport: "Ping para el informe ORD",
        sendPingForTowerSignalStrengthReport: "Informe de intensidad de señal de ping para la Estación base",
        sendAlarmsOnPriorityChannel: "Enviar alarmas en el canal prioritario",
        pingForTime: "Ping por tiempo",
        pingSentErrorMsg: "Errores al enviar el comando Ping {pingType} a las radios seleccionadas, ver registro",
        setupSendConfirm: "¿Estás segura de que quieres cambiar la configuración?",
        changeTuneState: "Cambiar estado de sintonización",
        steupTuning: "Estado de ajuste de configuración",
        sendMenu: 'Enviar',
        sendSetup: "Enviar comando de configuración",
        sendTargetCommandsToSelected: "Enviar comandos de destino a los seleccionados",
        sendTargetCommandsToSet: "Enviar comandos de destino al conjunto",
        setupSentUnknownErrMsg: "Comando de configuración enviado a radios seleccionadas",
        setupSentErrorMsg: "Errores al enviar el comando de configuración a las radios seleccionadas, ver registro",
        setupSentErrMsg: "Errores al enviar el comando de configuración a las radios seleccionadas: ",
        resetHysteresisForRadio: 'Restablecer histéresis',
        resetHysteresisForSelectedRadios: 'Restablecer histéresis para seleccionados',
        resetHysteresisForSet: 'Restablecer histéresis para conjunto',
        resetHysteresisForRadioSuccess: 'Restablecimiento de histéresis',
        resetHysteresisForSelectedRadiosSuccess: 'Restablecimiento de histéresis para {numRadios} radios',
        resetHysteresisForSetSuccess: 'Restablecimiento de histéresis enviado para el conjunto {setName}',
        resetAnalysisDaysForRadio: 'Restablecer días de análisis',
        resetAnalysisDaysForSelected: 'Restablecer días de análisis para seleccionados',
        resetAnalysisDaysForSet: 'Restablecer días de análisis para conjunto',
        resetAnalysisDaysForRadioSuccess: 'Días de análisis restablecidos',
        resetAnalysisDaysForSelectedSuccess: 'Días de análisis restablecidos para {numRadios} puntos finales',
        resetAnalysisDaysForSetSuccess: 'Restablecimiento de días de análisis enviado para el conjunto {setName}',
        resetAnalysisDaysFailed: 'Error al restablecer los días de análisis',
        staticRebroadcaster: "Transmisor Estático",
        vitalBuddyConfig: "Ajuste de objetivos de compañeros vitales",
        radioNotTunable: " no está en condiciones de emitir un comando de configuración, intente hacer ping a la radio",
        nonTunableRepeater: 'Repetidora no sintonizable',
        provenDate: 'Fecha probada',
        ordToStaticRebroadcasterDistance: 'Distancia entre ORD y retransmisor estático (millas)',
        tuneRadios: "Sintonizar Radios Seleccionadas",
        tuneMatchingRadios: "Realice la optimización del rendimiento",
        tuningRequestMade: "Sintonización de radios seleccionadas",
        tuningErrorMsg: "Error de sintonizar radios, ver registro",
        sendTargetsToSelectedRequestMade: 'Enviando objetivos a {numRadios} a {numRadiosExpected} radios',
        sendTargetsToSetRequestMade: 'Enviando objetivos para establecer {setName}',
        detailsTitle: "Detalles de la Radio",
        general: "General",
        transmitMode: "Modo de Transmisión",
        transmissionMode: "Modo de transmisión",
        receiveMode: "Modo de Recibir",
        receiveModeLat: "Modo de Recibir LAT",
        receiveModeMom: "Modo de Recibir MOM",
        locationStatus: "Estado de la ubicación",
        commsSection: 'Opciones de comunicación',
        statsSection: 'Estadísticas',
        msgStatsSection: 'Estadísticas de mensajes',
        msgStatsTT: 'Estadísticas calculadas a partir de mensajes recibidos desde la radio',
        baseStationSection: 'Conexión de estación base',
        uplinkTuningStats: 'Estadísticas de ajuste de enlace ascendente',
        uplinkTuningStatsTT: "Estadísticas de ajuste de enlace ascendente calculadas a partir del trabajo de ajuste diario",
        uplinkRouteStats: "Estadísticas de ruta de enlace ascendente",
        uplinkRouteStatsTT: "Estadísticas de ruta de enlace ascendente calculadas a partir del trabajo de ruta diario",
        downlinkRouteStats: "Estadísticas de ruta de enlace descendente",
        downlinkRouteStatsTT: "Estadísticas de ruta de enlace descendente calculadas a partir del trabajo de ruta diario",
        altitude: "Altitud",
        towersHeard: "Estaciones Base Escuchadas",
        towersHeardIDs: "Estaciones Base Escuchadas ID(es)",
        numTowersHeard: "Recuento de encabezados de estaciones base",
        closestTower: "Estación Base Más Cercana",
        bestTower: "Mejor Estación Base",
        timestamps: 'Marcas de Diempo',
        timeSync: "Última sincronización",
        inTimeSync: "Sincronización de tiempo",
        notInTimeSync: "Sin sincronización de tiempo",
        timeSyncState: {
            IN_SYNC: "Sí",
            NOT_IN_SYNC: "No",
            NOT_APPLICABLE: "No aplica",
            UNKNOWN: "No Establecido",
            null: "No Establecido"
        },
        alarms: {
            powerFailAlarmActive: "Estado de alarma de falla de energía",
            powerFailAlarmActiveItems: {
                active: "Activo",
                restored: "Restaurado",
                neverFailed: "Nunca falló"
            },
            powerFailAlarmStartDate: "Fecha de inicio de falla de energía",
            powerRestoreAlarmStartDate: "Fecha de restauración de energía",
            lastPowerFailOrRestoreAlarmDate: "Última alarma de fallo o restauración de energía",
            extendedPowerFailAlarm: "Alarma de falla de energía extendida",
            extendedPowerRestore: "Fallas de energía (todas) y restauraciones dentro",
            extendedPowerRestoreDate: "Intervalo de fechas de fallas de energía (todas) y restauraciones",
            tamperAlarmActive: "Alarma de sabotaje activa"
        },
        bestTowerUplink: "Mejor enlace ascendente de estación base",
        bestTowerUplinkRange:"Mejor enlace ascendente de estación base (rango)",
        bestTowerUplinkSprExport: "Mejor enlace ascendente de estación base (para archivo de exportación)",
        tuningBestTowerUplink: "Sintonización del mejor enlace ascendente de la estación base",
        tuningAvgSNR: "Sintonización de SNR",
        tuningAvgSS: "Intensidad de la señal de sintonización promedio",
        extendedPowerFailAlarm: "Alarma de falla de energía extendida",
        lastTowerReportDuration: 'Duración del informe de la última Estación base',
        transmitterEnabled: "Transmisor habilitado",
        lastTowerReport: "Informe de la última Estación base",
        lastUpdatedUplink: 'Última actualización de estadísticas de enlace ascendente',
        lastUpdatedDownlink: 'Última actualización de estadísticas de enlace descendente',
        bestTowerDownlink: "Mejor enlace descendente de estación base",
        bestTowerDownlinkRange: "Mejor enlace descendente de estación base(rango)",
        bestTowerDownlinkSprExport: "Mejor enlace descendente de estación base (para archivo de exportación)",
        lastPerformanceEvent: 'Último evento de rendimiento',
        lastPerformanceEventReason: 'Motivo del último evento de rendimiento',
        lastNoRouteCmdFailureActive: "Sin falla de ruta",
        lastReadFailureCount: 'Recuento de la última lectura fallida',
        capabilityState: 'Estado de capacidad',
        communicationState: 'Estado de comunicación',
        communicationStates: {
            ACTIVE: "Activa",
            NEWLY_HEARD: "Recién escuchada",
            NOT_HEARD: "No escuchada",
            POWER_FAILED: "Fallo de energía",
            REMOVED: "Remota",
            null: "No establecido"
        },
        active: "Activa",
        notActive: "No Activa",
        address: "Dirección",
        freqSupervisory: "Frecuencias de Supervisión",
        freqPriority: "Frecuencias de Prioridad",
        freqCnI: "Frequencies de C&I",
        freqBoost: "Aumentar las Frecuencias",
        freqReceive: "Recibir Frecuencias",
        factorySleep: "Sommeil d'usine",
        topLevelState: "Estado de Nivel Superior",
        topLevelStateNA2W: "NA2W Estado de Nivel Superior",
        topLevelStateHistory: "NA2W Estado de Nivel Superior Historia",
        topLevelStateNames: {
            Idle : "Ocioso",
            Walk_By_Drive_By : "Caminar por - Conducir por",
            Listen_After_Talk : "Escuchar Despues de Hablar",
            Middle_Of_Minute : "Medio minuto",
            Maintenance : "Mantenimiento",
            Active: "Activo",
            null: "No Establecido"
        },
        NCSCommandsSent: "Comandos NCS enviados",
        ncsCommandTypesArqiva: {
            PING_FOR_TIME: "Hacer ping por tiempo",
            PING_ORD_REPORT: "Informe de Ping ORD",
            PING_SIMPLE_SETUP: "Configuración simple de ping",
            PING_TOWER_SIGNAL_STRENGTH_REPORT: "Informe de intensidad de la señal de la Estación base de ping",
            SETUP: "Enviar comando de configuración",
        },
        ncsCommandTypesNA: {
            PING_SIMPLE_SETUP: "Configuración simple de ping",
            SETUP: "Enviar comando de configuración",
            PING_ADVANCED_SETUP: "Configuración avanzada de ping",
            PING_ESM_CONFIG: "Hacer ping a la configuración de ESM",
            PING_ESM_METADATA: "Hacer ping a los metadatos de ESM",
        },
        commands: {
            commandType: "Tipo de Comando",
            priority: "Prioridad",
            attempts: "Intentos",
            status: "Estado",
            user: "Iniciado por",
            lastSent: "Último Envío",
            nextSend: "Próximo Envío",
            cancel: "Cancelar Comando",
            globalDisable: "Desactivar Procesamiento de Comandos",
            globalEnable: "Activar Procesamiento de Comandos"
        },
        commandStatus: {
            CREATED: "Creado",
            QUEUED: "En Cola",
            IN_PROGRESS: "En Progreso",
            EXPIRED: "Caducado"
        },
        stats : {
            distanceToBestTower: "Distancia a la mejor Estación base (millas)",
            distanceToBestTowerDownlink: "Distancia desde la mejor estación base (millas)",
            rtsThroughput: "Rendimiento RTS %",
            lastRTS: "Último RTS",  
            l2ACKThroughput: "Rendimiento L2 ACK %",
            l2ACKSuccess: "Éxito de L2 ACK %",
            lastL2ACK: "Último L2 ACK",
            bulkThroughput: "Rendimiento de Bulk Up %",
            lastBulk: "Último Bulk Up",
            highestDownlinkTowerAverageUseCount: "Sincronización de tiempo Promedio de 7 días más alto",
            highestDownlinkTowerAverageUseCountReportDate: "Sincronización de hora Último cambio de Estación base",
            highestDownlinkTowerAverageUseCountReportDuration: "Duración del último cambio de Estación base de sincronización de hora",
            pingSetupCmdFailureCount: "Fallos del comando NCS",
            mPassSetupCmdFailureCount: "Fallos de configuración de mPass",
            lastNoRouteCmdFailure: "Última falla sin ruta",
            lastDownlinkRouteCountTitle: "Recuento de rutas de enlace descendente"
        },
        timeSyncDurations: {
            Day1: "1+ Días",
            Days7: "7+ Días",
            Days30Plus: "30+ Días"
        },
        transmitInterval: "Intervalo de Transmisión (STR)",
        transmitIntervalLat: "Intervalo de Transmisión (STR) LAT",
        transmitIntervalMom: "Intervalo de Transmisión (STR) MOM",
        receiveModesFNv1:{
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_ENABLED: "Compañero habilitado - futuro",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_FUTURE_LBT_BUDDY_MODE_DISABLED: "Compañero discapacitado - futuro",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED: "5 kbps, Buddy habilitado",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED: "5 kbps, amiga desactivada",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_10_KBPS: "10 kbps, Buddy habilitado",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED_10_KBPS: "10 kbps, amiga desactivada",
            UNKNOWN: "Desconocido",
            null: "No Establecido"
        },
        receiveModes: {
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED: "5 kbps, Buddy habilitado",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED: "5 kbps, amiga desactivada",
            LISTEN_ALWAYS_BUDDY_MODE_ENABLED_10_KBPS: "10 kbps, Buddy habilitado",
            LISTEN_ALWAYS_BUDDY_MODE_DISABLED_10_KBPS: "10 kbps, amiga desactivada",
            UNKNOWN: "Desconocido",
            null: "No Establecido"
        },
        receiveModesArqiva: {
            MPASS: "2GMSK 5K (mPass)",
            MPASS2: "2GMSK 10K (mPass2)",
            M4PASS: "4GMSK 10K (m4Pass)",
            M4PASS2: "4GMSK 20K (m4Pass2)"
        },
        transmissionModesArqiva: {
            SFSK2: "2SFSK",
            SFSK4: "4SFSK",
            SFSK8: "8SFSK",
            SFSK16: "16SFSK"
        },
        channel: "Canal",
        fec: 'FEC',
        bulkChannelUpDownErrMsg: "En la mayoría de los casos, no debería tener sus canales ascendentes y descendentes en la misma frecuencia",
        adminChannel: "Canal de administración",
        currentBulkChannelPair: "Par actual de canales masivos",
        noCurrentBulkChannelPair: "Par de canales masivos actual no establecido",
        noTargetBulkChannelPair: "El par de canales masivos de destino no está configurado",
        previousBulkChannelPair: "Par anterior de canales masivos",
        noPreviousBulkChannelPair: "Par de canales masivo anterior no establecido",
        currentUplinkFreq: "Frecuencia de enlace ascendente actual",
        currentDownlinkFreq: "Frecuencia actual del enlace descendente",
        previousUplinkFreq: "Anterior Frecuencia de enlace ascendente",
        previousDownlinkFreq: "Anterior Frecuencia de enlace descendente",

        channelNames: {
            C_AND_I: "C&I Canale",
            PRIORITY: "Prioridad Canale",
            BOOST: "Aumentar Canale",
            RECEIVE: "Recibir Canale",
            RECEIVE_B: "Recibir B Canale",
            SUPERVISORY: "de Supervisor Canale",
            BULK_DOWN: "Bulk Down Canale",
            BULK_DOWN_0: "Bulk Down 0 Canale",
            BULK_DOWN_1: "Bulk Down 1 Canale",
            BULK_DOWN_2: "Bulk Down 2 Canale",
            BULK_DOWN_3: "Bulk Down 3 Canale",
            BULK_DOWN_4: "Bulk Down 4 Canale",
            BULK_DOWN_5: "Bulk Down 5 Canale",
            BULK_DOWN_6: "Bulk Down 6 Canale",
            BULK_DOWN_7: "Bulk Down 7 Canale",
            BULK_DOWN_8: "Bulk Down 8 Canale",
            BULK_DOWN_9: "Bulk Down 9 Canale",
            BULK_DOWN_10: "Bulk Down 10 Canale",
            BULK_DOWN_11: "Bulk Down 11 Canale",
            BULK_DOWN_12: "Bulk Down 12 Canale",
            BULK_DOWN_13: "Bulk Down 13 Canale",
            BULK_DOWN_14: "Bulk Down 14 Canale",
            BULK_DOWN_CURRENT: "Bulk Down Canale",
            BULK_DOWN_PREVIOUS: "Bulk Down Previa Canale",
            BULK_UP: "Bulk Up Canale",
            BULK_UP_0: "Bulk Up 0 Canale",
            BULK_UP_1: "Bulk Up 1 Canale",
            BULK_UP_2: "Bulk Up 2 Canale",
            BULK_UP_3: "Bulk Up 3 Canale",
            BULK_UP_4: "Bulk Up 4 Canale",
            BULK_UP_5: "Bulk Up 5 Canale",
            BULK_UP_6: "Bulk Up 6 Canale",
            BULK_UP_7: "Bulk Up 7 Canale",
            BULK_UP_8: "Bulk Up 8 Canale",
            BULK_UP_9: "Bulk Up 9 Canale",
            BULK_UP_10: "Bulk Up 10 Canale",
            BULK_UP_11: "Bulk Up 11 Canale",
            BULK_UP_12: "Bulk Up 12 Canale",
            BULK_UP_13: "Bulk Up 13 Canale",
            BULK_UP_14: "Bulk Up 14 Canale",
            BULK_UP_CURRENT: "Bulk Up Canale",
            BULK_UP_PREVIOUS: "Bulk Up Previa Canale",
            L2ACK_1: "L2ACK 1 Canale",
            L2ACK_2: "L2ACK 2 Canale",
            L2ACK_3: "L2ACK 3 Canale",
            RTS: "RTS Canale"
        },
        radioDetailChannelNames: {
            C_AND_I: "C&I",
            PRIORITY: "Prioridad",
            BOOST: "Aumentar",
            RECEIVE: "Recibir",
            RECEIVE_B: "Recibir B",
            SUPERVISORY: "de Supervisor",
            BULK_DOWN: "Bulk Down",
            BULK0: "Bulk Par 0",
            BULK1: "Bulk Par 1",
            BULK2: "Bulk Par 2",
            BULK3: "Bulk Par 3",
            BULK4: "Bulk Par 4",
            BULK5: "Bulk Par 5",
            BULK6: "Bulk Par 6",
            BULK7: "Bulk Par 7",
            BULK8: "Bulk Par 8",
            BULK9: "Bulk Par 9",
            BULK10: "Bulk Par 10",
            BULK11: "Bulk Par 11",
            BULK12: "Bulk Par 12",
            BULK13: "Bulk Par 13",
            BULK14: "Bulk Par 14",
            BULK_DOWN_0: "Bulk Down 0",
            BULK_DOWN_1: "Bulk Down 1",
            BULK_DOWN_2: "Bulk Down 2",
            BULK_DOWN_3: "Bulk Down 3",
            BULK_DOWN_4: "Bulk Down 4",
            BULK_DOWN_5: "Bulk Down 5",
            BULK_DOWN_6: "Bulk Down 6",
            BULK_DOWN_7: "Bulk Down 7",
            BULK_DOWN_8: "Bulk Down 8",
            BULK_DOWN_9: "Bulk Down 9",
            BULK_DOWN_10: "Bulk Down 10",
            BULK_DOWN_11: "Bulk Down 11",
            BULK_DOWN_12: "Bulk Down 12",
            BULK_DOWN_13: "Bulk Down 13",
            BULK_DOWN_14: "Bulk Down 14",
            BULK_DOWN_CURRENT: "Bulk Down Actual",
            BULK_DOWN_PREVIOUS: "Bulk Down Previa",
            BULK_UP: "Bulk",
            BULK_UP_0: "Bulk Up 0",
            BULK_UP_1: "Bulk Up 1",
            BULK_UP_2: "Bulk Up 2",
            BULK_UP_3: "Bulk Up 3",
            BULK_UP_4: "Bulk Up 4",
            BULK_UP_5: "Bulk Up 5",
            BULK_UP_6: "Bulk Up 6",
            BULK_UP_7: "Bulk Up 7",
            BULK_UP_8: "Bulk Up 8",
            BULK_UP_9: "Bulk Up 9",
            BULK_UP_10: "Bulk Up 10",
            BULK_UP_11: "Bulk Up 11",
            BULK_UP_12: "Bulk Up 12",
            BULK_UP_13: "Bulk Up 13",
            BULK_UP_14: "Bulk Up 14",
            BULK_UP_CURRENT: "Bulk Up Actual",
            BULK_UP_PREVIOUS: "Bulk Up Previa",
            BULKCURRENT: "Bulk Actual Par",
            BULKPREVIOUS: "Bulk Previa Par",
            L2ACK_1: "L2ACK 1",
            L2ACK_2: "L2ACK 2",
            L2ACK_3: "L2ACK 3",
            RTS: "RTS"
        },
        channelNamesExpected: {
            C_AND_I: "Expected C&I Channel",
            PRIORITY: "Expected Priority Channel",
            BOOST: "Expected Boost Channel",
            RECEIVE: "Expected Receive Channel",
            RECEIVE_B: "Expected Receive B Channel",
            SUPERVISORY: "Expected Supervisory Channel",
            L2ACK_1: "Expected L2ACK 1",
            L2ACK_2: "Expected L2ACK 2",
            L2ACK_3: "Expected L2ACK 3",
            RTS: "Expected RTS",
            bulkUplinkFreq: "Expected Bulk Uplink Frequency",
            bulkDownlinkFreq: "Expected Bulk Downlink Frequency",
        },
        bulkPair: "Par a granel",
        currentBulkPair: 'Actual Bulk Par',
        changingBulkPair: 'Cambiar a Bulk Par {index}',
        changingFrequency: 'Cambio de Frequency a {name}',
        changingModulation: 'Cambio de Modulation a {name}',
        disableFlexnetTransmitter: 'Deshabilitar transmisor',
        enableFlexnetTransmitter: 'Habilitar transmisor',
        disabledFlexnetTransmitter: 'Transmisor deshabilitado',
        enabledFlexnetTransmitter: 'Transmisor habilitado',        
        previousBulkPair: 'Previa Bulk Par',
        targetBulkPair: 'Objetivo Bulk Par',
        radiosByModulation: "ESM Radio por Modulación y FEC",
        noFilter: "noFilter",
        multipleSats: "dosStats",
        supervisoryModulation: "Modulación de supervisión",
        supervisoryFEC: "FEC de supervisión",
        supervisoryTarget: "Objetivo de supervisión",
        supervisoryModulationTarget: "Objetivo de modulación de supervisión",
        receiveModulation: "Recibir modulación",
        receiveTarget: "Recibir objetivo",
        receiveModulationTarget: "Recibir objetivo de modulación",
        priorityModulation: "Modulación prioritaria",
        priorityTarget: "Objetivo prioritario",
        priorityModulationTarget: "Objetivo de modulación prioritario",
        candiModulation: "C & I Modulación",
        candiTarget: "C & I Objetivo",
        candiModulationTarget: "C & I Modulación Objetivo",
        boostModulation: "Aumenta Modulación",
        boostTarget: "Impulsar objetivo",
        boostModulationTarget: "Objetivo de modulación de impulso",
        rtsModulation: "Modulación RTS",
        rtsTarget: "Objetivo RTS",
        rtsModulationTarget: "Objetivo de modulación RTS",
        bulkUpModulation: "Modulación de volumen",
        bulkUpTarget: "Objetivo de aumento de volumen",
        bulkUpModulationTarget: "Modulación objetivo de aumento masivo",
        bulkDownModulation: "Modulación descendente masiva",
        bulkDownTarget: "Objetivo de reducción masiva",
        bulkDownModulationTarget: "Modulación de destino masiva hacia abajo",
        l2Ack1Target: "L2ACK 1 objetivo",
        l2Ack1Modulation: "L2ACK 1 Modulación",
        l2Ack1ModulationTarget: "L2ACK 1 Modulation objetivo",
        l2Ack2Target: "L2ACK 2 objetivo",
        l2Ack2Modulation: "L2ACK 2 Modulación",
        l2Ack2ModulationTarget: "L2ACK 2 Modulation objetivo",
        l2Ack3Target: "L2ACK 3 objetivo",
        l2Ack3Modulation: "L2ACK 3 Modulación",
        l2Ack3ModulationTarget: "L2ACK 3 Modulation objetivo",
        esmReads: "ESM Lee Ayer",
        esmSnapshots: "ESM Instantáneas por Lectura",
        frequency: "Frecuencia (MHz)",
        modulation: "Modulación",
        modulations: {
            FSK_DISABLED: 'Discapacitada',
            FSK7: '7FSK',
            FSK13: '13FSK 1/2 FEC',
            FSK13_R34: '13FSK 3/4 FEC',
            FSK_CNI: 'C&I - 7FSK Half-Baud',
            FSK_PRI: 'Priority - 13FSK Half-Baud',
            FSK_BOOST: 'Boost',
            FSK13_BOTH: '13FSK BOTH',
            SFSK2: '2SFSK',
            SFSK4: '4SFSK',
            SFSK8: '8SFSK',
            SFSK16: '16SFSK',
            SFSK2_HB: '2SFSK Half-Baud',
            SFSK4_HB: '4SFSK Half-Baud',
            SFSK8_HB: '8SFSK Half-Baud',
            SFSK16_HB: '16SFSK Half-Baud',
            MPASS: 'mPass - 5 kbps',
            MPASS2: 'mPass2 - 10 kbps',
            M4PASS: 'm4Pass - 10 kbps',
            M4PASS2: 'm4Pass2 - 20 kbps',
            MPASS12K: 'mPass 12K',
            RADIO_SFSK2: "Radio 2SFSK",
            RADIO_SFSK4: "Radio 4SFSK",
            SFSK_BOOST: "SFSK Boost",
            FSK13_REDUCED: "13FSK Reduced",
            FSK13_EXTENDED: "13FSK Extended",
            UNKNOWN: 'No Establecida',
            null: 'No Establecido'
        },
        fullmPassMode: 'Modo mPass completo',
        ordFullMpass: 'ORD (Modo mPass completo)',
        lowPowerEnabled: "Modo de bajo consumo habilitado",
        lowPowerMode: "Modo de bajo consumo",
        mptPercentage: "MPT %",
        lastUpdated: 'Últimas Estadísticas Diarias Actualizadas',
        endpointSnr: "SNR del terminal",
        endpointNoise: "Ruido del terminal",
        tuningNoise: "Ruido de sintonización",
        uplinkEndpointSnr: "SNR del punto final de enlace ascendente",
        downlinkEndpointSnr: "SNR del punto final de enlace descendente",
        use24Ct: "Cuenta de uso de 24 Hora",
        timeSyncCount: "Promedio móvil de recuento de sincronización de tiempo",
        useCount: "Promedio Recuento de uso (por día)",
        useCount7Days: "Usage Count",
        useCount7DaysTooltip: "Number of times this route was used over the last 7 days from the given date",
        uplinkUseCount: "Recuento de uso de enlaces ascendentes",
        uplnkUseCount: "Promedio diario de recuento de uso de enlace ascendente",
        dwnlnkUseCount: 'Promedio diario de recuento de uso de enlace descendente',
        avgSignalStrength: "Intensidad de señal promedio (por día)",
        uplnkAvgSignalStrength: "Intensidad de la señal de enlace ascendente Promedio diario",
        dwnlnkAvgSignalStrength: "Intensidad de la señal de enlace descendente Promedio diario",
        lastUsed: "Utilizado Ultima",
        uplnkLastUsed: "Enlace ascendente utilizado por última vez",
        dwnlnkLastUsed: "Enlace descendente utilizado por última vez",
        daysRouteUsed: "Días Ruta Utilizada",
        daysRouteUsedTooltip: "Días en que se utilizó esta ruta durante el rango de tiempo indicado",
        routes: "Enlace ascendente Rutas Utilizadas en los Ultimos {dataRetentionDays} Días",
        buddyRepeat: "Buddy Repetir",
        uplinkFrequency: "Uplink Supervisory Frecuencia",
        destId: "Destino ID",
        destType: "Destino Tipo",
        routeCount: "Recuento de Rutas",
        routeCountTitle: 'Recuento de rutas de enlace ascendente',
        routeCountsPerTime: "Recuento diario de rutas",
        location: {
            location: "Ubicación",
            gps: {
                latitude: "Latitud",
                longitude: "Longitud",
                latLongStatusTitle: 'Estado de la ubicación',
                latLongStatus: 'Estado de la ubicación'
            },
            streetAddress: {
                zipCode: "Código postal"
            }
        },
        channels: {
            channels: "Canals",
            BOOST: {
                frequencyTitle: "Aumentar las Frecuencias"
            },
            C_AND_I: {
                frequencyTitle: "Frequencies de C&I"
            },
            PRIORITY: {
                frequencyTitle: "Frecuencias de Prioridad"
            },
            RECEIVE: {
                frequencyTitle: "Recibir Frecuencias"
            },
            SUPERVISORY: {
                frequencyTitle: "Frecuencias de Supervisión"
            }
        },
        uplinkRoutes: {
            repeatedMessagesCount: "Mensajes Repetidos",
            lastORDReportTime: "Último informe ORD",
        },
        detailsTargetTT: 'Cambiando a {targetValue}',
        arqivaTitles: {
            uplinkRouteCount: "Promedio de rutas de enlace ascendente",
            uplinkRouteCountsPerTime: "Promedio de recuento de rutas de enlace ascendente {dateString}",
            downlinkRouteCount: "Promedio de rutas de enlace descendente",
            downlinkRouteCountPerTime: "Promedio de recuento de rutas de enlace descendente {dateString}",
            snrDirections: "SNR Avg (enlace ascendente / descendente)",
            bestTowerDirections: "Mejor Estación base (enlace ascendente / descendente)",
            towersHeard: "Estaciones base escuchadas",
            uplinkRoutes: {
                lastORDReportTime: "Último informe ORD",
            },
            lastORDReportDuration: "Duración del informe ORD",
            lifeCycleStates: {
                INSTALL: 'Instalado',
                INVENTORY: 'Inventario',
                NOT_ASSIGNED: 'No Asignado',
                UNKNOWN: "Desconocido",
                REMOVED: 'Remota',
                null: 'Desconocido',
            }
        },
        lastORDReportDuration: "Duración del último informe ORD",
        receiveOperationalModeTitle: "Modo de Funcionamiento del Receptor",
        topLevelStateTitle: "Estado de Nivel Superior",
        deviceTypeTitle: "Tipo de dispositivo",
        multipleStatsTitle: "ESM Radio por Modulación y FEC",
        utilityTypeTitle: "Tipo de utilidad",
        effectiveTransmitOperationalModeTitle: "Modo Operativo del Transmisor",
        effectiveSupervisoryTransmitIntervalTitle: "Intervalo de Transmisión (STR)",
        SNR: 'SNR',
        avgSNRTooltip: 'SNR promedio más reciente',
        uplnkAvgSNRTooltip: 'SNR diario de enlace ascendente promedio para el período de tiempo seleccionado',
        dwnlnkAvgSNRTooltip: 'SNR promedio diario de enlace descendente para el período de tiempo seleccionado',
        avgSSTooltip: 'Fuerza de señal promedio más reciente',
        uplnkAvgSSTooltip: 'Intensidad de la señal diaria de enlace ascendente promedio para el período de tiempo seleccionado',
        dwnlnkAvgSSTooltip: 'Intensidad media de la señal diaria del enlace descendente para el período de tiempo seleccionado',
        useCountTooltip: 'Recuento de uso más reciente',
        uplnkUseCountTooltip: 'Recuento promedio de uso diario de enlace ascendente para el período de tiempo seleccionado',
        dwnlnkUseCountTooltip: 'El promedio móvil diario de la cantidad de sincronizaciones horarias de estaciones base escuchadas durante los últimos 7 días.',
        avgSNRGraphTitle: 'SNR Promedio de los Ultimos 7 Días',
        avgSSGraphTitle: 'Señal Promedio de los Ultimos 7 Días',
        useCountGraphTitle: 'Recuento Uso de los Ultimos 7 Días',
        lowestSNR: 'SNR Más Bajo',
        oneRoute: 'Una Ruta',
        multipleRoutes: 'Ruta Múltiple',
        snrThresholdTitle: 'Umbral máximo de SNR',
        radioStales: "Grapas RF",
        radiosUplinkRouteCount: "Recuentos de radio por categoría de recuento de rutas de enlace ascendente",
        radiosDownlinkRouteCount: "Recuentos de radio por categoría de recuento de rutas de enlace descendente",
        routeCountRange: {
            ZERO: "0",
            ONE: "1",
            TWO_TO_SIX: "2-6",
            TWO_TO_TEN: "2-10",
            SEVEN_OR_MORE: "7+",
            ELEVEN_OR_MORE: "11+"
        },
        fnFirmwareVersion: "Versión de firmware de FlexNet",
        firmwareVersion: "Versión de firmware",
        hostFirmwareVersion: "Versión de firmware del host",
        sdkFirmwareVersion: 'Versión de firmware',
        fwdlDates: 'Fecha de descarga del firmware',
        ncoHistoryId: 'Última actualización de ajuste',
        destTypes: {
            0: 'Estacion Base',
            1: 'Amigo',
            2: 'FNv2 Amigo'
        },
        avgSnrTrend: 'SNR Tendencia de 7 Días',
        avgSignalStrengthTrend: 'Fuerza de Señal de 7 Días',
        useCountTrend: 'Recuento de Uso de 7 Días',
        errors: {
            retrieveDetails: 'Error al recuperar los detalles de la radio para la identificación del representante {id}',
            retrieveFrequencies: 'Error al recuperar frecuencias de filtro',
            retrieveRoutes: 'Error al recuperar rutas',
            retrieveOrdRoutes: 'Error al recuperar las rutas ORD',
            retrieveBuddyRoutes: 'Error al recuperar Buddy Routes',
            retrieveTower: 'Error retrieving towers for radio'
        },
        snr: 'Relación señal / ruido de enlace ascendente',
        snrGraphLabel: 'dB',
        signalStrengthPerRoute: "Intensidad de señal por ruta",
        useCountPerRoute: "Usar recuento por ruta",
        MsgToBuddy: 'Mensajes recibidos de dispositivos fuera del alcance',
        MsgToBuddyGraphLabel: 'Contar',
        MsgFromORD: 'Mensajes enviados a Buddy',
        MsgFromORDGraphLabel: 'Contar',
        radioConfig: 'Configuración de radio',
        configuration: 'Configuración',
        showRadiosTT: 'Ver Radios',
        db: {
            seriesFrequency: 'Frec',
            seriesBuddy: '(Amigo)',
            graphError: 'Error al recuperar los datos del gráfico para {graphName}',
            dest: 'Dest',
            destination: 'Destino',
            snrTT: 'Relación señal / ruido de enlace ascendente',
            signalStrengthTitle: 'Intensidad de la señal de enlace ascendente',
            signalStrengthGraphLabel: 'dB',
            msgsSentToBuddyTitle: 'Mensajes Enviados a Amigo',
            msgsFromOrdTitle: 'Mensajes Recibidos de ORD',
            ssTitle: 'Fuerza de señal promedio',
            ssTT: 'Fuerza de señal promedio para esta radio',
            useCountTitle: 'Cuenta de uso promedio por ruta',
            useCountTT: 'Cuenta de uso promedio por ruta para esta radio',
            lifeCycleStateTitle: 'Estado del Ciclo de Vida',
            staleHistoryTitle: 'Recuentos Históricos Pasados',
            topLevelStateTSTitle: 'Conteos Estatales de Nivel Superior'
        },
        stales: "RF Pasados",
        staleFilters:{
            Day1: "1 Día",
            Days2: "2 Dias",
            Days3: "3 Dias",
            Days4Plus: "4+ Dias"
        },
        powerFailure: {
            onePlusHr: "1+ hora",
            fourPlusHr: "4+ horas",
            eightPlusHr: "8+ horas",
            twelvePlusHr: "12+ horas"
        },
        powerRestore: {
            "Min30Less": "Últimos 30 minutos",
            "Hour1Less": "Ultima hora",
            "Hour12Less": "Últimas 12 horas",
            "Days1Less": "Último día",
            "Days3Less": "Últimos 3 días",
        },
        StaleRadios:{
            "1Day": "1 Día",
            "2Day": "2 Dias",
            "3Day": "3 Dias",
            "4PlusDays": "4+ Dias"
        },
        lifecycleState: "Estado del Ciclo de Vida",
        lifecycleStates: {
            INSTALL: 'Instalado',
            INVENTORY: 'Inventario',
            NOT_ASSIGNED: 'No Asignado',
            RETIRED: 'Retirado',
            RMA: 'ADM',
            REMOVED: 'Eliminado',
            SWAP: 'Intercambiado',
            UNKNOWN: "Desconocido",
            null: 'Desconocido',
        },
        flexnetVersion: "Versión FlexNet",
        flexnetVersions: {
            NA:{
                null: "Desconocido",
                FNV1: "FNV1",
                FNV2: "FNV2",
            },
            arqiva:{
                null: "Desconocido",
                CommsHub: "CommsHub"
            }
        },
        encryptionState: "Cifrada",
        effectiveTransmitOperationalMode: "Modo operativo del transmisor",
        effectiveSupervisoryTransmitInterval: "Intervalo de transmisión (STR)",
        receiveOperationalMode: "Modo operativo del receptor",
        bestAverageSNRDownlink: "Enlace descendente promedio diario SNR",
        needSetup: "Necesita configuración",
        tableFilterTuningOptions: {
            SYSTEM_TUNED: "Actualizaciones automáticas por sistema",
            MANUAL_TUNED: "Actualizaciones manuales por usuario",
            SYSTEM_SUGGEST: "El sistema sugiere actualizaciones pero no realiza ninguna acción",
        },
        tuningOptions: {
            SYSTEM_TUNED: "Actualizaciones automáticas por sistema",
            SYSTEM_SUGGEST: "El sistema sugiere actualizaciones pero no realiza ninguna acción",
        },
        tuning: {
            capabilityState: 'Estado de capacidad',
            capabilityStates: {
                CONFIGURABLE: 'Configurable',
                READ_PINGS: 'Leer Pings',
                NONE: 'Ninguna',
                UNKNOWN: 'Desconocida',
                null: 'No establecido'
            },
            ruleCurrentMatches: "Radios según la regla de sintonización actual",
            ruleTargetMatches: "Historial de cola de configuración de radio",
            ruleAllocation: "Cola de configuración de radio",
            frequencyConfig: "Objetivos de frecuencia de sintonización",
            notPlanned: "No en la configuración del canal",
            tuningOption: "Acciones de ajuste posteriores",
            currentGroup: "Grupo de sintonización actual",
            targetGroup: "Grupo de ajuste de destino",
            otherGroups: "Grupos de acción",
            reason: "Razón de ajuste",
            needSetupReason: "Necesita motivo de configuración",
            inProgress: "Sintonización en curso",
            setupCommandInProgress: 'Sintonización en curso',
            isORD: 'ORD',
            isTempORD: "Estado ORD temporal",
            lastAnalysisDate: "Último análisis de ajuste de rutas de enlace ascendente",
            changeLastAnalysisDate: "Cambiar la configuración de Días de análisis de ajuste de rutas de enlace ascendente",
            isTunableDeviceType: "Tipo de dispositivo sintonizable",
            lastTuningDate: "Último intento de ajuste del sistema",
            lastTuningChainUpdate: "Última actualización de la cadena de afinación",
            lastNCOAnalysis: "Último análisis periódico de NCO",
            lastNCOGroupAssignmentTime: "Última asignación grupal de NCO",
            lastPeriodicChannelBalanceAnalysis: "Último análisis periódico de equilibrio de canales",
            membershipGroup: "Nobre de regla de membresía coincidente",
            actionGroup: "Nombre de la regla de acción coincidente",
            actionEnabled: "Acción habilitada",
            actionDisabled: "Acción deshabilitada",
            isSuspectedORD: "ORD Sospechoso",
            defaultRuleMembershipString: "Radios que no coinciden con ninguna otra regla",
            rapidTune: {
                rapidTuneAvgTimeOnChannel: 'Tiempo promedio de sintonización rápida en el canal',
                rapidTuneEndpointsTuned: 'Rapid Tune Puntos finales ajustados',
                rapidTuneEndpointsPerChannel: 'Puntos finales de ajuste rápido por canal',
                rapidTuneTimeToTune: 'Rapid Tune hora de sintonizar',
                rapidTuneSweepTime: 'Rapid Tune tiempo de barrido',
                rapidTuneTimeToTuneAve: 'Rapid Tune tiempo medio para sintonizar',
                rapidTuneSweepTimeAve: 'Rapid Tune tiempo medio de barrido',
                rapidTuneRadiosCount: 'Radios sintonizados rápidamente',
                channelAvg: {
                    timeOnInstallChannel: 'Tiempo en el canal de instalación',
                    timeOnAdminChannel: 'Tiempo en el canal de admin',
                    timeToRapidTuneCompletion: 'Tiempo para completar la puesta a punto rápida',
                }
            },
            uplinkSamples: 'Muestras de enlace ascendente recibidas',
            downlinkSamples: 'Muestras de enlace descendente recibidas',
            exitTime: 'Rapid Tune hora de salida',
            stdDev: 'Desviación estándar',
            rapidTuneChannels: {
                ADMIN: 'Canal de administración',
                BULK: 'Bulk canal',
                INSTALL: 'Instalar canal',
                COMPLETION: 'Terminada',
            },
            rapidTuneStatus: {
                ALREADY_KNOWN: 'Ya conocido por RNI',
                BULK_CHANNELS_UNAVAILABLE:"Canal masivo no disponible",
                BUDDY_ROUTE_DETECTED: 'Ruta de amigos detectada',
                BULK_TARGETS_SELECTED: 'Canal de destino masivo seleccionado',
                //CHANNELS_UNAVAILABLE: 'Canales no disponibles',
                COLLECTING_DATA: 'Recopilando datos',
                INSTALL: 'Movido al canal de instalación',
                INSTALL_TARGETS_SELECTED: 'Instalar destinos seleccionados',
                INSTALL_CHANNELS_UNAVAILABLE: 'Canales de instalación no disponibles',
                NO_TUNING_CHANGES: "El balanceo de canales no produjo cambios",
                PENDING_READ_ONLY: 'Pendiente de sólo lectura',
                TUNING_COMPLETED: 'Ajuste completado',
                TUNING_EXPIRED: 'Sintonización caducada',
                WAITING_INSTALL_TIME_THRESHOLD: 'Esperando el umbral de tiempo de instalación',
                WAITING_RNI_IMPORT: 'Esperando la importación de RNI',
                WAITING_STATIC_SETUP: 'Esperando configuración estática'
            },
            rapidTuneTargets: {
                canales: 'Canales',
                currentChannelPair: 'Par de canales actual',
                targetChannelPair: "Par de canales de destino",
                fullMPassMode: 'Modo MPass completo',
                lowPowerEnabled: 'Baja potencia habilitada',
                mPassBuddyRepeatEnabled: 'Repetición de amigo MPass habilitada',
                staticRebroadcaster: 'Static Rebroadcaster',
                tuningOption: 'Opción de ajuste',
                minPriority: 'Prioridad mínima'
            },
            notMoving: "No se mueve",
            movingIn: "Mudándose",
            movingOut: "Mudarse",
            tuningResultFlags: 'Banderas de Resultados de Ajuste',
            tuningResultFlagValue: {
                CHANNEL_BALANCE_RESET_CHANNEL: 'Equilibrio de canales - Restablecer canal'
            }
        },
        maxReadGapMins: 'Brecha máxima de lectura',
        maxReadGapMinsFilter: 'Brecha máxima de lectura (minuts)',
        readChanceOfFailure: 'Probabilidad de error de lectura',
        readNormalThroughput: 'Rendimiento de lectura - Normal',
        readRepeatedThroughput: 'Rendimiento de lectura - Compañero',
        readBoostedThroughput: 'Rendimiento de lectura - Impulsado',
        historyDepthMins: 'Profundidad promedio del historial de lectura',
        minReadHistoryMinutes: 'Historial de lectura mínima (minutos)',    
        recentPerformanceEvent: 'Evento de rendimiento reciente',
        couldNotComputeReadGaps: 'No se pudieron calcular los intervalos de lectura',
        couldNotComputeThroughputs: 'No se pudieron calcular los rendimientos',
        readTypes: {
            REPEATED: 'Repetido',
            NORMAL: 'Normales',
            POLLED: 'Encuestados',
            BOOSTED: 'Aumentar'
        },
        isTuningTooltip: "<b>NetTune will:</b><ul>" +
            "<li>Cambie la transmisión y recepción de este punto final a los valores seleccionados</li>" +
            "<li>Cambie este punto final a un canal diferente en función de la carga frente a la capacidad</li></ul>" +
            "<b>NetTune may:</b><ul>" +
            "<li>Utilice este terminal como compañero para admitir dispositivos fuera de alcance</li>" +
            "<li>Utilice este punto final como un retransmisor estático para admitir dispositivos fuera de alcance</li></ul>",
        tuneCommsHubFromFile: 'Sintonizar Comms Hub desde archivo',
        tuneRadiosFromFile: 'Sintonizar radios desde archivo',
        invalidSetupConfigFile: 'Columna no válida, asegúrese de que todas las columnas sean válidas',
        tuneCommsHubInvalidFileSize: 'Archivo no válido cargado, se puede ajustar un máximo de 100 concentradores de comunicaciones a la vez',
        tuneCommsHubUploadSuccess: 'Archivo subido',
        tuneCommsHubFromFileErr: 'Archivo inválido',
        noRuleDiff: "No se detectan diferencias, no se guardarán",
        addRadioToSet: 'Agregar radio para configurar',
        removeRadioFromSet: 'Quitar radio del conjunto',
        addRadioToSetTitle: 'Agregar radio para configurar',
        removeRadioToSetTitle: 'Quitar radio del conjunto',
        singleRadioPingSentMsg: 'Comando ping enviado a la radio',
        singleRadioPingSentErrorMsg: 'Error al enviar el comando Ping {pingType} a la radio, ver registro',
        singleRadioSetupSentErrorMsg: "Error al enviar el comando de configuración a la radio, ver registro",
        singleRadioTuningRequestMade: "Sintonizando la radio",
        singleRadioTuningErrorMsg: "Error al sintonizar la radio, ver registro",
        detailActionsSubTitle: 'Acciones de radio',
        commandCanceled: "Comando {tipo} cancelado para radio {radio}",
        commandCanceledErrorMsg: "No se pudo cancelar el comando {tipo} para la {radio}, solo se pueden cancelar los comandos en estado En cola",
        setGlobalCommandSettingErrorMsg: "Error al cambiar la configuración de procesamiento de comandos globales, consulte el registro",
        sync :{
            RNI_Radios: "Sincronizar Radios desde RNI",
            successSyncRadioRNI : "Sincronización de radio iniciada con éxito desde RNI",
            syncRadiosRNIError: "Error de sincronización, ver registro",
        },
        dailyDurations: {
            Day1: "1 Día",
            Days1Plus: "1+ Dias",
            Days1Less: "Hace 1 día o menos",
            Days2: "2 Dias",
            Days2Less: "Hace 2 días o menos",
            Days3: "3 Dias",
            Days4Plus: "4+ Dias",
            Days4Less: "Hace 4 días o menos",
            Days4PlusAndNull: "4+ Dias o nunca escuchad",
            Days7Plus: "7+ Dias",
            Days7PlusAndNull: "7+ Dias o nunca escuchadoor",
            Days7Less: "Hace 7 Dias o menos",
            Days8Plus: "8+ Dias",
            Days8PlusAndNull: "8+ Dias o nunca escuchado",
            Days30Plus: "30+ Dias",
            Days30Less: "Hace 30 dias o menos"
        },
        navToGroup: "Navegar a la definición de grupo para ",
        transmitsPerMAL: 'Transmisiones por período MAL',
        transmitIntervalWhitelist: 'Lista blanca de intervalos de transmisión',
        modulationsNA: {
            FNV1: {
                FSK_DISABLED: 'Disabled',
                FSK7: '7FSK',
                FSK13: '13FSK',
                FSK13_R34: '13FSK R34',
                FSK_CNI: 'C&I - 7FSK Half-Baud',
                FSK_PRI: 'Priority - 13FSK Half-Baud',
                FSK_BOOST: 'Boost',
                FSK13_BOTH: '13FSK BOTH',
                SFSK2: '2SFSK',
                SFSK4: '4SFSK',
                SFSK8: '8SFSK',
                SFSK16: '16SFSK',
                SFSK2_HB: '2SFSK Half-Baud',
                SFSK4_HB: '4SFSK Half-Baud',
                SFSK8_HB: '8SFSK Half-Baud',
                SFSK16_HB: '16SFSK Half-Baud',
                MPASS: 'mPass - 5 kbps',
                MPASS2: 'mPass2 - 10 kbps',
                M4PASS: 'm4Pass - 10 kbps',
                M4PASS2: 'm4Pass2 - 20 kbps',
                MPASS12K: 'mPass 12K',
                RADIO_SFSK2: "Radio 2SFSK",
                RADIO_SFSK4: "Radio 4SFSK",
                SFSK_BOOST: "SFSK Boost",
                FSK13_REDUCED: "13FSK Reduced",
                FSK13_EXTENDED: "13FSK Extended",
                UNKNOWN: 'Unknown',
            },
            FNV2: {
                FSK_DISABLED: 'Disabled',
                FSK7: '7FSK',
                FSK13: '13FSK',
                FSK13_R34: '13FSK R34',
                FSK_CNI: 'C&I - 7FSK Half-Baud',
                FSK_PRI: 'Priority - 13FSK Half-Baud',
                FSK_BOOST: 'Boost',
                FSK13_BOTH: '13FSK BOTH',
                SFSK2: '2SFSK',
                SFSK4: '4SFSK',
                SFSK8: '8SFSK',
                SFSK16: '16SFSK',
                SFSK2_HB: '2SFSK Half-Baud',
                SFSK4_HB: '4SFSK Half-Baud',
                SFSK8_HB: '8SFSK Half-Baud',
                SFSK16_HB: '16SFSK Half-Baud',
                MPASS: 'mPass - 5 kbps',
                MPASS2: 'mPass2 - 10 kbps',
                M4PASS: 'm4Pass - 10 kbps',
                M4PASS2: 'm4Pass2 - 20 kbps',
                MPASS12K: 'mPass 12K',
                RADIO_SFSK2: "Radio 2SFSK",
                RADIO_SFSK4: "Radio 4SFSK",
                SFSK_BOOST: "SFSK Boost",
                FSK13_REDUCED: "13FSK Reduced",
                FSK13_EXTENDED: "13FSK Extended",
                UNKNOWN: 'Unknown',   
            }
        },
        fecNA: {
            FNV1: {
                THREE_QUARTER_K7: '3/4 Rate, K=7',
                THREE_QUARTER_K4: '3/4 Rate, K=4',
                HALF: '1/2 Rate, K=3',
                NONE: 'None',
            },
            FNV2: {
                THREE_QUARTER_K7: '3/4 Rate, K=7',
                THREE_QUARTER_K4: '3/4 Rate, K=4',
                HALF: '1/2 Rate, K=3',
                NONE: 'None',
            }
        },
        transmitModesNA: {
            NORMAL: "Normal",
            MESSAGE_PASS: "MPass",
            BOOST_MODE: "Boost Mode",
            NORMAL_HALF_BAUD_RATE: "Half Baud Rate",
            MPASS_NORMAL_MIX_1_1: "MPass 1:1",
            MPASS_NORMAL_MIX_1_2: "MPass 1:2",
            MPASS_NORMAL_MIX_1_3: "MPass 1:3",
            MPASS_NORMAL_MIX_1_4: "MPass 1:4",
            MPASS_NORMAL_MIX_1_5: "MPass 1:5",
            MPASS_NORMAL_MIX_1_8: "MPass 1:8",
            MPASS_NORMAL_MIX_1_16: "MPass 1:16",
            BOOST_NORMAL_MIX_1_1: "Boost Mode 1:1",
            BOOST_NORMAL_MIX_1_2: "Boost Mode 1:2",
            BOOST_NORMAL_MIX_1_3: "Boost Mode 1:3",
            BOOST_NORMAL_MIX_1_4: "Boost Mode 1:4",
            BOOST_NORMAL_MIX_1_5: "Boost Mode 1:5",
            BOOST_NORMAL_MIX_1_8: "Boost Mode 1:8",
            TRI_MODE_1_1_13: "Tri Mode 1:1:3",
            UNKNOWN: "Desconocido",
            null: "No establecido"
        },
        transmitModesArqiva: {
            NORMAL: "Normal",
            MESSAGE_PASS: "MPass",
            UNKNOWN: "Desconocido",
            null: "No establecido"
        },
        clearRequiredFiltersDialogNA: "Los siguientes filtros son necesarios para las reglas de configuración. <br/>" +
        "Serán eliminados de la lista de miembros.<br/><br/>" +
        "Versión Flexnet, ESM, espacio de lectura máximo<br/>><br/>" +
        "¿Estás seguro de que quieres continuar?",
        clearRequiredFiltersDialogArqiva: "Los siguientes filtros son necesarios para las reglas de configuración. <br/>" +
        "Serán eliminados de la lista de miembros.<br/><br/>" +
        "SNR del punto final de enlace descendentebr/>><br/>" +
        "¿Estás seguro de que quieres continuar?",    
        UPLINK: "enlace ascendente",
        DOWNLINK: "enlace descendente",
        ALL: "Todos",
        POLL_RESPONSE: "Respuesta de encuesta",
        reads: 'Lee',
        sampleCount: 'Recuento de muestras',
        failCount: 'Recuento de fallas',
        toi: 'Tiempo de intercepción',
        readTime: 'Tiempo de lectura',
        tuningOptionsHeader: 'Opciones de ajuste',
        requiredCriteria: 'Criterios requeridos',
        communicationMode: 'Modo de restricción AMI',
        communicationModes: {
            null: '',
            'UNKNOWN': 'Sin cambios',
            'AMI': 'Modo AMI',
            'OPT_OUT': 'Modo de exclusión voluntaria',
            'ON_DEMAND': 'Modo bajo demanda'
        },
        lastReadHadFailure: 'La última lectura tuvo un error',
        lastReadFailureDate: 'Fecha del último error de lectura',
        appDataSize: 'Tamaño de datos de la aplicación',
        lastReadMsgBoosted: 'Último mensaje leído impulsado',
        lastReadMsgNormal: 'Último mensaje leído normal',
        lastReadMsgPolled: 'Último mensaje sondeado leído',
        lastReadMsgRepeated: 'Último mensaje leído como amigo',
        currentConfigWhitelisted: "Configuración actual en la lista blanca",
        modFecCombination: "Modulación y FEC",
        comparisonFilter: 'Filtro de comparación',
        comparisonFilterMembershipCriteria: '',
        shorthand: {
            flexnetVersion: "FNV",
            bestAverageSNR: "SNR",
            tuning: {
                maxReadGapMins: 'Read Gap',
                readChanceOfFailure: 'Read COF',
                minReadHistoryMinutes: 'History',
            },
            device: {
                esm: 'ESM',
                meterSampleRateTitle: "Frecuencia de muestreo (MSR)"
            },
            tuneMatchingRadios: "Sintonización",
            stats: {
                bestTowerAverageSNRDownlink: 'SNR de enlace descendente'
            },
            tuningBestUplinkTower: {
                averageSNR: 'SNR de enlace ascendente'
            },
            modulation: 'Mod',
            fullMPassMode: 'mPass'
        },
        tempHints: {
            tuning: {
                isSuspectedORD: "Se usa para identificar puntos finales que parecen ORD independientemente de la configuración actual de mPassEnabled./nSe usa en reglas de ajuste para identificar puntos finales que parecen estar configurados como ORD.\nConfigure MIN_DOWNLINK_DIRECT_ROUTE_SS y DIRECT_ROUTE_DAYS para ajustar cuando se establece este indicador.",
                capabilityState: "Calculado durante el ajuste.\nUNKNOWN cuando el modo de comunicación (indicador AMI) es desconocido y la versión del firmware admite AMI.\nCONFIGURABLE cuando un punto final ajustable tiene un estado de ciclo de vida instalado, inventario, no asignado; el estado de comunicación no se elimina; no en falla de energía extendida y no tiene fallas de lectura de hardware.\nREAD_PINGS si está en medidores de administración de lectura.\nNONE si el modo de comunicación está desactivado o bajo demanda o no cumple con otros estados.",
                lastCalculatedTuningGroup: "En el momento de la última ejecución del trabajo de la cadena de ajuste, este era el grupo de ajuste cuya configuración OBJETIVO coincide con la configuración actual de este punto final. Esto solo representa la configuración actual del punto final y NO crea ningún cambio de ajuste futuro. Este campo no está disponible en NMS.",
                minReadHistoryMinutes: "Profundidad mínima del historial en minutos utilizados en la última sintonización. Calculado durante la ejecución de la cadena de sintonización NA desde la profundidad del historial de lectura. ESM ajustado para la modulación actual/objetivo 13FSK.",
                maxReadGapMins: "Lapso de tiempo más grande en minutos entre 2 mensajes leídos durante READ_ANALYSIS_DAYS. Solo hay un espacio si es mayor que 2 * velocidad de transmisión de radio. Calculado durante la cadena de sintonización NA ejecutada desde el historial de lectura. lastPerformanceEvent restablecerá la profundidad del historial. ESM mira los mensajes NORMALES , Non esm NORMAL, IMPULSO, REPETIDO.",
                readChanceOfFailure: "0 a 100 por ciento de probabilidad de que omitamos lecturas en el período MAL. Calculado por 1 menos la suma de los rendimientos elevados a transmitsPerMAL. Calculado durante la ejecución de la cadena de sintonización NA. El período de tiempo de latencia máxima permitida (MAL) se configura en cada criterios de regla de ajuste. Las transmisiones de destino por MAL se definen en la acción de regla.",
                readNormalThroughput: "Número de lecturas normales recibidas / Número de lecturas normales esperadas. El modo operativo de transmisión de la radio define el número de lecturas esperadas durante READ_ANALYSIS_DAYS o lastPerformanceEventDate. Calculado durante la sintonización NA a partir de lecturas.",
                historyDepthMins: "Promedio móvil ponderado del promedio del historial de muestra de lectura diaria sobre READ_ANALYSIS_DAYS para esta radio en el momento de la última ejecución de la cadena de sintonización. Promedio móvil calculado a partir del promedio diario: readHistorySampleCountTotal/readHistorySampleMsgCountTotal * la frecuencia de muestreo de la radio usando smoothingFactorHistoryDepth. Para rendimiento y para tener un único cálculo consistente, esto es intencionalmente diferente de las múltiples formas en que NMS calculó este valor.",
                isTempORD: "Un punto final que tiene rutas de amigos (estaba en un informe ORD) y fullMPASS = false"
            },
            tuningBestUplinkTower: {
                averageSNR: "Promedio de 7 días de la señal de este punto final menos el promedio de 7 días de ruido en la estación base para el canal de enlace ascendente.",
                tuningBestTowerUplink: "Estación base que escuchó este punto final con la mejor sintonización SNR.",
                tuningNoise: "SNR promedio menos intensidad de señal promedio."
            },
            tuningOption: {
                SYSTEM_TUNED: "Quiero que NCS administre este punto final, sugiera objetivos y reconfigure.",
                MANUAL_TUNED: "Quiero administrar manualmente los objetivos de ajuste, pero que NCS realice las reconfiguraciones.",
                SYSTEM_SUGGEST: "Quiero ver los objetivos de ajuste que NCS seleccionaría para este punto final, pero no quiero que NCS realice la reconfiguración."
            },
            communicationState: "Campo actualizado por un trabajo que examina varios otros campos.\nNo se escucha cuando LastHeard es nulo.\nSe escucha recientemente cuando FirstHeard tiene más de 168 horas.\nSe elimina cuando LastHeard tiene más de 720 horas.\nActivo cuando FirstHeard está entre 720 y 168 horas.\nSe produjo un error de energía cuando powerFailAlarmActive es verdadero y la fecha de inicio es posterior a 168 horas; las anteriores a 168 horas se eliminan. Los usuarios con permisos elevados pueden configurar 168 y 720.",
            NA:{
                routeCount: "Número de rutas utilizadas por la radio ayer. Calculado durante el trabajo de rutas diarias."
            },
            Arqiva: {
                routeCount: "Número de rutas utilizadas por la radio la última vez que se escuchó la radio dentro de 10 días ({purgeDate}). Calculado durante el trabajo de rutas diarias."
            }
        },
        RapidTuneSweepTime: "Tiempo promedio de barrido",
        expectedStaticRebroadcaster: "Retransmisor estático esperado",
        expectedmPassBuddyRepeatEnabled: 'Repetición esperada de mPass Buddy',
        expectedFullMPassMode: 'Modo mPass completo esperado',
        expectedLowPowerEnabled: 'Baja potencia esperada',
        expectedTransmitterEnabled: 'Transmisor esperado',
        expectedTransmitOperationalMode: 'Modo operativo del transmisor esperado',
        expectedReceiveOperationalMode: 'Modo operativo del receptor esperado',
        expectedChannelPairId: 'ID de par de canales esperado',
        expectedColumnNotSortable: 'Esta columna no se puede ordenar porque los datos se calculan en el servidor',
    },
    deviceTypes: {
        0: "0 - Transmit Only iCon Electric Meter",
        1: "1 - Transceiver iCon Electric Meter",
        3: "3 - Water Meter",
        4: "4 - TGB RF Card",
        5: "5 - Elster A3 C&I FlexNet Radio",
        6: "6 - FlexNet Water Meter",
        7: "7 - FlexNet Gas",
        8: "8 - iCon Integrated Display",
        9: "9 - APX Integrated Display",
        10: "10 - Handheld",
        11: "11 - Buddy Box",
        12: "12 - Copper Fault Current Indicator",
        13: "13 - ZigBee Gateway",
        14: "14 - Canon Multi-Utility",
        15: "15 - Poletop Repeater",
        16: "16 - Thermostat",
        17: "17 - Propane Sensor",
        18: "18 - L&G Focus AL Energy Only FlexNet Radio",
        19: "19 - L&G Focus AX Time of Use",
        20: "20 - Aclara I-210+C Time of Use Radio with MSP430F5437",
        21: "21 - Aclara I-201+ Energy Only",
        22: "22 - APX Integrated Display with Zigbee",
        23: "23 - iConA TOU Integrated Display",
        24: "24 - iConA Zigbee Module with MSP430F5438",
        25: "25 - Thumb Buddy Box",
        26: "26 - EOL Thumb Buddy Box",
        27: "27 - FlexNet Network Portal (FNP)",
        28: "28 - In-Home Display",
        29: "29 - iConA TOU Metrology Processor",
        30: "30 - iCon AP Metrology Processor",
        31: "31 - iCon APX Metrology Processor",
        32: "32 - Elster A3 Metrology Processor",
        33: "33 - iCon Integ. Disp w/ AMI FW DL",
        34: "34 - Elster A3 C&I with 512KB Flash",
        35: "35 - Load Shed Box",
        36: "36 - Cooper Serial",
        37: "37 - FlexNet Remote Portal",
        38: "38 - L&G AL_kWh/L&G_AX_TOU",
        39: "39 - EOL FMT",
        40: "40 - FlexNet Metpod",
        41: "41 - miniFNP",
        42: "42 - L+G S4e FlexNet Radio",
        43: "43 - L+G S4e Metrology Processor",
        44: "44 - L+G Focus AX Metrology Processor",
        45: "45 - Blue Tooth Micro Transceiver",
        46: "46 - CommandLink (PHIT)",
        47: "47 - North American 2-Way Water",
        48: "48 - North American 2-Way Gas",
        49: "49 - Elster A3 C&I FlexNet Radio (with MSP430F5437)",
        50: "50 - iConAS TOU Integrated Display",
        51: "51 - L&G Focus AX FlexNet Radio (with MSP430F5437)",
        52: "52 - iConAS TOU Metrology Processor",
        53: "53 - Distribution Automation (Generic Transceiver)",
        54: "54 - U-SNAP Radio (with MSP430F5437)",
        55: "55 - Aclara kV2c Radio",
        56: "56 - Aclara kV2c Metrology Processor",
        57: "57 - Honeywell A3 Alpha",
        58: "58 - NA2W Gas Shutoff Valve",
        59: "59 - iConAS 400MHz",
        60: "60 - PRI Comms Module",
        61: "61 - PRT i-Credit 500 Meter",
        62: "62 - FMT USB",
        63: "63 - MLC or SLC Radio",
        64: "64 - NA2W Water Shutoff Valve",
        65: "65 - TGB PA Controller",
        66: "66 - Sensus iCon APX C& with MSPF430F537",
        67: "67 - Aclara SM112 400MHz FlexNet Radio",
        68: "68 - NA2W Three Port Gas Corrector",
        69: "69 - USNAP2 (with MSP430F5437)",
        70: "70 - L+G Zigbee Module with MSP450F5438",
        71: "71 - Zigbee End Device",
        72: "72 - Liberty Gas (400MHz with integrated shutoff)",
        73: "73 - 400MHz standalone Gateway",
        74: "74 - Low-power FlexNet radio module for Gateway",
        75: "75 - Zigbee radio module for Gateway",
        76: "76 - Elster Zigbee Module",
        77: "77 - EDMI MK7 FlexNet Radio",
        78: "78 - Combo Bluetooth/USB FMT (with MSP430F5437)",
        79: "79 - EDMI MK7B ESI",
        80: "80 - EDMI MK7B Meter",
        81: "81 - High Power Load Control Module Radio",
        82: "82 - High Power FlexNet Gateway Radio",
        83: "83 - iConAS Enhanced Radio (CC1120 with MSP430F5437)",
        84: "84 - Han Serial 3rd Party Device",
        85: "85 - 3rd Party Zigbee ESI",
        86: "86 - Sensus Lighting Control (SLC) Radio",
        87: "87 - EDMI MK7 Enhanced Radio (CC1125 with MSP430F5437)",
        88: "88 - EDMI 1-CAN",
        89: "89 - Water Register",
        90: "90 - L+G Focus AX FlexNet Enhanced Radio (CC1120 with MSP430F5437)",
        91: "91 - Multi-FMT",
        92: "92 - UK-Comms Hub NXP-SDK",
        93: "93 - R100E Repeater",
        94: "94 - UK-Comms Hub NXP-SDK-Fylingdales",
        95: "95 - iPerl Hat",
        96: "96 - StratusIQ with NXP K24 ARM Processor",
        97: "97 - StratusIQ with NXP KV31 ARM Processor",
        98: "98 - NextGen Zigbee Module with EM359x",
        99: "99 - Wireless Water Register",
        100: "100 - GE i210 Metrology Processor",
        101: "101 - Raw Metrology",
        102: "102 - Battery Endpoint",
        103: "103 - PHIT II",
        104: "104 - Cathodic Protection Metrology",
        105: "105 - Aclara i210 NextGen Radio with Freescale K22 ARM Processor",
        106: "106 - CP Mains Endpoint",
        107: "107 - CP Rectifier Monitor",
        108: "108 - Sensus Tool",
        109: "109 - Aclara kV2c NextGen Radio with Freescale K22 ARM Processor",
        110: "110 - Honeywell A3 Alpha",
        111: "111 - DA RTM FlexNet Radio Module",
        112: "112 - R100NA Repeater",
        113: "113 - R10NA Repeater",
        114: "114 - FlexModem",
        115: "115 - Gas Register",
        116: "116 - iPERL ASIC",
        117: "117 - Line Powered VantagePoint Radio",
        118: "118 - Line Powered VantagePoint Meter",
        119: "119 - NetGen LCM with K24",
        120: "120 - Cellular Modem",
        121: "121 - StratusIQ FlexNet with STM32 ARM Processor",
        122: "122 - StratusIQ Metrology with STM32 ARM Processor",
        123: "123 - GE kV2c NextGen Radio with STM32 ARM Processor",
        124: "124 - Stratus Evolve FlexNet",
        125: "125 - Stratus Evolve Metrology",
        UNKNOWN: "Desconocido",
        null: "No Establecido"
    },
    deviceTypeCategories: {
        oneWayWaterMeters: 'Medidores de agua unidireccionales',
        badMetrologyMeters: 'Medidores de metrología defectuosos',
        elsterMeters: 'Medidores de Elster',
        na2wLightingMeters: 'Medidores de iluminación Na2w',
        tunableMeters: 'Medidores sintonizables',
        lightingEndpoints: 'Puntos finales de iluminación',
        electricCommercialMeters: 'Medidores comerciales eléctricos',
        waterMeters: 'Medidores de agua',
        lgMeters: 'Medidores LG',
        gasMeters: 'Medidores de gas',
        na2wShutoffValves: 'Válvulas de cierre de Na2w',
        slottedPollResponseDevices: 'Dispositivos de respuesta de encuesta ranurados',
        compulsoryRepeaters: 'Repetidores obligatorios',
        oneWayGasMeters: 'Medidores de gas OneWay',
        electricMeters: 'Medidores electricos',
        na2wWaterGasMeters: 'Medidores de gas de agua Na2w',
        electricResidentialMeters: 'Medidores residenciales eléctricos',
        readManagementMeters: 'Leer medidores de gestión'
    },
    locationStatus: {
        INVALID_COORDINATES: "Inválid Lat/Lng",
        VALID_COORDINATES: "Válid Lat/Lng",
        ZERO_ZERO_COORDINATES: "0,0 Lat/Lng"
    },
    utilityTypes: {
        ELECTRIC: "Eléctrico",
        ONE_WAY_GAS: "Gas unidireccional",
        GAS: "Gas bidireccional",
        INFRASTRUCTURE: "Infraestructura",
        LIGHTING: "Iluminación",
        ONE_WAY_WATER: "Agua unidireccional",
        WATER: "Agua bidireccional",
        UNKNOWN: "Desconocido",
        null: "No Establecido"
    },
    routeCountValues: {
        0: "0",
        1: "1",
        MULTIPLE: "2+"
    },
    tuningFilterValues: {
        deviceType: {
            92: "92 - UK-Comms Hub NXP-SDK",
            93: "93 - R100E Repeater",
            94: "94 - UK-Comms Hub NXP-SDK-Fylingdales",
        }
    },
    setupReasons : {
        null: "Cualquier razón"
    },
    rapidTuning: {
        updateRapidTuningConfig: 'Actualizar configuración de ajuste rápido'
    }
}
